import { Zap, Building, Truck, Landmark, Layers, Cpu, Heart, Flag } from 'lucide-react';
import ScrollReveal from '@/components/ScrollReveal';

const sectors = [
  { label: 'Energy & Utilities', Icon: Zap },
  { label: 'Real Estate', Icon: Building },
  { label: 'Transport & Logistics', Icon: Truck },
  { label: 'Financial Institutions', Icon: Landmark },
  { label: 'Infrastructure', Icon: Layers },
  { label: 'Technology', Icon: Cpu },
  { label: 'Healthcare', Icon: Heart },
  { label: 'Sovereign & Government', Icon: Flag },
];

export default function Sectors() {
  return (
    <section id="sectors" className="py-20 sm:py-28" style={{ backgroundColor: '#0a1628' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <ScrollReveal>
          <p className="text-sm font-inter font-semibold uppercase tracking-wider mb-3" style={{ color: '#c9a84c' }}>
            Sector Expertise
          </p>
          <h2 className="font-playfair font-bold text-3xl sm:text-4xl text-white mb-12">
            Deep Knowledge Across Key Industries
          </h2>
        </ScrollReveal>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {sectors.map(({ label, Icon }, i) => (
            <ScrollReveal key={label} delay={i * 70}>
              <div
                className="p-6 rounded-xl text-center group"
                style={{
                  backgroundColor: '#0f2240',
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '12px',
                  transition: 'transform 300ms ease, border-color 300ms ease, box-shadow 300ms ease',
                  cursor: 'default',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.borderColor = '#c9a84c';
                  e.currentTarget.style.boxShadow = '0 8px 30px rgba(201,168,76,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
                data-testid={`sector-card-${i}`}
              >
                <Icon className="w-8 h-8 mx-auto mb-3" strokeWidth={1.5} style={{ color: '#c9a84c' }} />
                <span className="font-inter text-sm font-medium" style={{ color: '#d1d5db' }}>{label}</span>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
